import { get } from 'helpers/api';
import camelcaseKeys from 'camelcase-keys';

export const CHANGE_RECORDS = 'CHANGE_RECORDS';
export function changeRecords(imports, importRequests, meta) {
  return {
    imports,
    importRequests,
    meta,
    type: CHANGE_RECORDS
  };
}

export const RETRIEVE_RECORDS_STARTED = 'RETRIEVE_RECORDS_STARTED';
export function retrieveRecordsStarted() {
  return { type: RETRIEVE_RECORDS_STARTED };
}

export function retrieveImports() {
  return (dispatch, getState) => {
    const { paths, query } = getState();
    dispatch(retrieveRecordsStarted());
    return get(paths.imports, { params: { page: query.importPage } }).then((response) => {
      const data = camelcaseKeys(response, { deep: true });
      return dispatch(changeRecords(data.imports, [], data.meta));
    });
  };
}

export function retrieveImportRequests() {
  return (dispatch, getState) => {
    const { paths, query } = getState();
    dispatch(retrieveRecordsStarted());
    return get(paths.importRequests, { params: { page: query.importRequestPage } }).then((response) => {
      const data = camelcaseKeys(response, { deep: true });
      return dispatch(changeRecords([], data.importRequests, data.meta));
    });
  };
}
